<template lang="html">
  <div id="contact-page">

    <section class="container oversized-container content-section">
      <div class="row align-items-center">
        <div class="col-12 mb-3 mb-lg-4 col-title">
          <h2 class="common-title pt-2">{{ $t("shared.titles.contact") }}</h2>
        </div>

        <div class="col-lg-8 col-map">
          <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d6055.866890866925!2d-111.8599671!3d40.6313497!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x875262788f878ea5%3A0xbff901558a71f230!2s1250%20E%206600%20S%2C%20Murray%2C%20UT%2084121%2C%20EE.%20UU.!5e0!3m2!1ses-419!2smx!4v1739899854034!5m2!1ses-419!2smx" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
        </div>

        <div class="col-lg-4 col-info">
          <h5 class="title">{{ $t("footer.titles.phone") }}</h5>
          <p>801 759 5815 </p>

          <h5 class="mt-4 title">{{ $t("footer.titles.addresstitle") }}</h5>
          <p class="p-lg">
            {{ $t("footer.titles.address1") }}<br />
						{{ $t("footer.titles.address2") }}
          </p>

          <h5 class="mt-4 title">{{ $t("footer.titles.email") }}</h5>
          <p class="p-lg">
            info@eslowindows.com<br />
          </p>

          <p class="mt-3 p-lg">
            <a target="_blank" href="https://www.facebook.com/profile.php?id=61566874502482&mibextid=LQQJ4d&mibextid=LQQJ4d">
              <i class="fab fa-facebook"></i> Facebook
            </a>
          </p>
          <p class="mt-3 p-lg">
            <a target="_blank" href="https://www.instagram.com/eslo_usa/profilecard/?igsh=MXd6czIwZWVwZnZxZw==">
              <i class="fa-brands fa-instagram"></i> Instagram
            </a>
          </p>
        </div>
      </div>
    </section>

  </div>
</template>

<script>
export default {
}
</script>
